import React, { lazy, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { CartContext } from "../context/CartContext";

// Cargamos el componente de búsqueda de forma diferida
const Search = lazy(() => import("./Search"));

const Header = () => {
  const navigate = useNavigate();
  const { cart, cartIconRef, clearCart } = useContext(CartContext);
  const isLoggedIn = !!localStorage.getItem("token");

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userId");
    clearCart();
    navigate("/account/signin");
  };

  // Calcular la cantidad total de productos en el carrito
  const totalQuantity = cart.reduce((total, item) => total + item.quantity, 0);

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark py-3">
      <div className="container-fluid">
        {/* Logo y nombre de la empresa */}
        <Link className="navbar-brand d-flex align-items-center" to="/">
          <img 
            src="../../images/logo.jpeg" 
            alt="Presto Enterprise Logo" 
            style={{ height: "70px", marginRight: "10px" }} 
          />
        </Link>

        {/* Botón de Toggle para móviles */}
        <button 
          className="navbar-toggler" 
          type="button" 
          data-bs-toggle="collapse" 
          data-bs-target="#navbarContent" 
          aria-controls="navbarContent" 
          aria-expanded="false" 
          aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarContent">
          {/* Menú principal */}
          <ul className="navbar-nav me-auto mb-2 mb-lg-0 fs-4">
            <li className="nav-item">
              <Link className="nav-link" to="/">Inicio</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/category">Productos</Link>
            </li>
            {/* <li className="nav-item">
              <Link className="nav-link" to="/account/wishlist">Favoritos</Link>
            </li> */}
            <li className="nav-item">
              <Link className="nav-link" to="/invoices">Compras</Link>
            </li>
          </ul>

          {/* Carrito con icono mejorado */}
          <Link 
            to="/cart" 
            className="btn btn-primary position-relative me-3" 
            ref={cartIconRef}>
            <i className="bi bi-cart-check fs-3"></i>
            {totalQuantity > 0 && (
              <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger fs-6">
                {totalQuantity}
                <span className="visually-hidden">items in cart</span>
              </span>
            )}
          </Link>

          {/* Menú de usuario con icono mejorado */}
          <div className="btn-group">
            <button 
              type="button" 
              className="btn btn-secondary rounded-circle border" 
              data-bs-toggle="dropdown">
              <i className="bi bi-person-circle fs-3 text-light"></i>
            </button>
            <ul className="dropdown-menu dropdown-menu-end fs-5">
              {isLoggedIn ? (
                <>
                  {/* <li>
                    <Link className="dropdown-item" to="/account/profile">Mi Perfil</Link>
                  </li> */}
                  <li>
                    <button className="dropdown-item" onClick={handleLogout}>Cerrar Sesión</button>
                  </li>
                </>
              ) : (
                <>
                  <li>
                    <Link className="dropdown-item" to="/account/signin">Iniciar Sesión</Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="/account/signup">Crear Cuenta</Link>
                  </li>
                </>
              )}
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Header;
